import {
  MtFormContainer,
  MtLayouTitleEditButton,
  MtLayouTitleEditButtonContainer,
  MtLayoutTitleWrapper,
  SectionTitle,
} from '@presentation/components';
import { MtLayouTitleBackButton } from '@presentation/components/MtLayout/styled';
import { useTranslation } from '@presentation/utils';
import type { FC } from 'react';
import { FaArchive, FaChevronLeft, FaEdit, FaTrash } from 'react-icons/fa';
import { PageSkeleton } from './components/PageSkeleton';
import type { MtAnimalBuyerPageProps } from './types';

export * from './types';

export const MtAnimalBuyerPage: FC<MtAnimalBuyerPageProps> = (props) => {
  const {
    mode,
    formComponent,
    onEditClick,
    onDeleteClick,
    onBackClick,
    archived = false,
    onUnarchiveClick,
    loading = false,
  } = props;
  const { translate } = useTranslation();

  return (
    <MtFormContainer>
      {loading && <PageSkeleton />}
      {!loading && (
        <>
          {!!onBackClick && (
            <MtLayouTitleBackButton onClick={onBackClick}>
              <FaChevronLeft />
              <div>{translate('common.buttons.back')}</div>
            </MtLayouTitleBackButton>
          )}
          <MtLayoutTitleWrapper>
            <SectionTitle>
              {translate(mode === 'new' ? 'common.buttons.newAnimal' : 'mt.header.digitalPassport')}
            </SectionTitle>

            <MtLayouTitleEditButtonContainer>
              {archived && (
                <>
                  <MtLayouTitleEditButton onClick={onUnarchiveClick}>
                    <span>{translate('common.buttons.unarchive')}</span>
                    <FaArchive />
                  </MtLayouTitleEditButton>
                </>
              )}
              {!archived && mode === 'view' && (
                <>
                  <MtLayouTitleEditButton onClick={onEditClick}>
                    <span>{translate('common.buttons.edit')}</span>
                    <FaEdit />
                  </MtLayouTitleEditButton>
                  <MtLayouTitleEditButton onClick={onDeleteClick} color="red">
                    <span>{translate('common.buttons.archive')}</span>
                    <FaTrash />
                  </MtLayouTitleEditButton>
                </>
              )}
            </MtLayouTitleEditButtonContainer>
          </MtLayoutTitleWrapper>
          {formComponent}
        </>
      )}
    </MtFormContainer>
  );
};
